<script setup lang="ts">
import type { DisciplineScheduleGridSlot } from '../model/interfaces'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'

import { useDisciplineScheduleDay } from '../model/discipline-schedule-day.hook'

defineOptions({
  name: 'DisciplineScheduleDay',
})

const props = defineProps<{
  day: string
  slots: DisciplineScheduleGridSlot[]
}>()

const {
  refName,
  refIsSelected,
  refHasSelectable,
  refTooltip,
  toggleDay,
} = useDisciplineScheduleDay({
  day: computed(() => props.day),
  slots: computed(() => props.slots),
})
</script>

<template>
  <div :class="['discipline-schedule-day', { selected: refIsSelected }]">
    <AppTooltip
      :text="refTooltip"
      size="small"
    >
      <button
        type="button"
        class="discipline-schedule-day__button"
        :disabled="!refHasSelectable"
        @click="toggleDay"
      >
        <AppText
          name="body1-medium"
          :color="refIsSelected ? 'blue-600' : 'slate-900'"
        >
          {{ refName }}
        </AppText>
      </button>
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineScheduleDay.scss" />
